export const drawerConfig = {
  headerPadding: "0 1.5rem",
  contentPadding: "0 1.5rem",
  css: () => `
    .p-drawer-right {
      width: auto;
    }
  `,
};
